<template>
  <div class="sm-awards">
    <div class="banner">
      <img src="../../../../assets/activity/lj-banner.jpg" alt="">
    </div>
    <div class="bg-wrap">
      <div class="msg txt-align">
        <span>摘要：</span>
        <span>
          “GF60绿色金融奖”评选活动由绿色金融60人论坛发起主办，旨在遴选优秀的绿色金融机构与案例，为绿色金融发展提供示范样本，鼓励持续探索绿色金融发展与创新，引导加大绿色产业的资金支持力度，让绿色金融更好助力经济社会绿色低碳高质量发展。
        </span>
      </div>

      <div class="sma-nav-list">
        <div
            v-for="(item, i) in smaNavList"
            :key="item.ele"
            :class="{
              'nav-item': true,
              'nav-item-wide': [3, 4, 8, 9].indexOf(i) >= 0,
              'nav-item-bt': i <= 3,
              'active-nav': currentTabMenu == item.ele
            }"
            @click="clickNav(item.ele)"
        >{{item.tit}}</div>
      </div>

      <div class="pxdt sma-pane-box" id="pxdt">
        <div class="pane-tit">评选动态</div>
        <div class="pre-list">
          <div v-for="(item, i) in ljpxList" :key="i" class="pre-box" @click="jumpPage(item)">
            <div class="left">
              <p class="txt-align">{{item.title}}</p>
              <div>
                <span>{{item.source}}</span>
                <span>{{item.date}}</span>
              </div>
            </div>
            <div class="right">
              <img :src="item.imgUrl"  alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="hjmd sma-pane-box" id="hjmd">
        <div class="pane-tit">获奖名单</div>
        <div class="award-box award-1">
          <img src="../../../../assets/activity/award-1.png" class="hjmd-img" alt="">
          <div class="com-list">
            <div v-for="(item, i) in zjjrjg" :key="i">{{item}}</div>
          </div>
        </div>
        <div class="award-box award-2">
          <img src="../../../../assets/activity/award-2.png" class="hjmd-img" alt="">
          <div class="com-list">
            <div v-for="(item, i) in zjjrjg" :key="i">{{item}}</div>
          </div>
        </div>
      </div>

<!--      <div class="xcsp sma-pane-box" id="xcsp">-->
<!--        <div class="pane-tit">现场视频</div>-->
<!--        <div class="video-wrap">-->
<!--          <video-player-->
<!--              class="video-player vjs-custom-skin"-->
<!--              ref="videoPlayer"-->
<!--              :playsinline="true"-->
<!--              :options="playerOptions"-->
<!--          />-->

<!--          <p>绿色金融60人论坛宣传片</p>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="jctj sma-pane-box" id="jctj">-->
<!--        <div class="jctj-pane-tit">-->
<!--          <div class="pane-tit">精彩图集</div>-->
<!--        </div>-->

<!--        <swiper :options="swiperOptions">-->
<!--          <swiper-slide-->
<!--              class="swiper-slide"-->
<!--              v-for="(item, i) in awardImgs"-->
<!--              :key="i"-->
<!--          >-->
<!--            <div class="img-list" >-->
<!--              <div v-for="(citem, ci) in item">-->
<!--                <img preview="1" :src="citem" :key="ci">-->
<!--              </div>-->
<!--            </div>-->
<!--          </swiper-slide>-->
<!--        </swiper>-->
<!--        <div class="sma-pagination"></div>-->
<!--      </div>-->

      <div class="footer-point sma-pane-box">
        注：以上名单按照首字母排序
      </div>
    </div>
  </div>
</template>

<script>
import {smaNavList, ljpxList, awardImgs, zjjrjg, zjcxsj} from '../common/summitMeetingData'

export default {
  name: "SMAwards",
  data() {
    return {
      smaNavList, ljpxList, awardImgs, zjjrjg, zjcxsj,
      currentTabMenu: 'pxdt',
      playerOptions: {
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4", // 类型
          src: 'https://gf60.org.cn/upload/video/video-01.mp4' // url地址
        }],
        poster: 'https://gf60.org.cn/upload/owe/29b110306ca441df85b524d5f54c531d.png', // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },
      swiperOptions: {
        autoplay: true,
        duration: 5000,
        pagination: {
          el: '.sma-pagination',
          clickable: true
        }
      },
    }
  },
  methods: {
    clickNav(el) {
      this.currentTabMenu = el;
      document.getElementById(el).scrollIntoView({ block: 'start', behavior: 'smooth' });
    },
    jumpPage(item) {
      window.open(item.link);
    },
    onWindowScroll() {
      const paneList = document.querySelectorAll('.sma-pane-box');
      for(let i = 0; i < paneList.length; i++) {
        const ele = paneList[i];
        const eleOT = ele.offsetTop;
        const wst = document.documentElement.scrollTop || document.body.scrollTop;
        if(wst > eleOT - 200 && wst < eleOT + 60) {
          let id = ele.id;
          if(id === 'jctj') id = 'sptj';
          this.currentTabMenu = id;
        }
      }
    },
    watchDOMScroll() {
      window.addEventListener('scroll', this.onWindowScroll);
    }
  },
  created() {
    this.watchDOMScroll();
  },
}
</script>

<style lang="less">
.mobile-home {
  .sm-awards {
    .banner {
      img {
        display: block;
        width: 100%;
      }
    }
    .bg-wrap {
      background: linear-gradient(#022b93, #051a4d);
      margin-bottom: -52px;
      padding-bottom: 100px;
      .sma-pane-box {
        padding: 26px;
        padding-top: 87px;
        margin-top: -61px;
      }

      .msg {
        padding: 15px 26px 20px;
        line-height: 1.6em;
        font-size: 13px;
        position: relative;
        z-index: 10;
        span {
          &:nth-child(1) {
            color: #67D0EC;
            font-weight: bold;
          }
          &:nth-child(2) {
            color: #fff;
            a {
              font-size: 12px;
              color: #123CDE;
              text-decoration: none;
              float: right;
            }
          }
        }
      }

      .sma-nav-list {
        background: linear-gradient(#FDF2C0, #DBA34A);
        padding: 10px 26px;
        display: flex;
        position: sticky;
        top: 0;
        z-index: 3;
        div {
          margin-right: 15px;
        }
        .active-nav {
          color: #123CDE;
          font-weight: bold;
        }
      }

      .pane-tit {
        font-size: 16px;
        padding-bottom: 10px;
        border-bottom: 1px solid #D2D2D2;
        background-image: url("../../../../assets/activity/tit-lj.png");
        background-repeat: no-repeat;
        background-size: 1.1em;
        padding-left: calc(1.1em + 10px);
        background-position: 0 .15em;
        color: #67D0EC;
        &.no-border {
          border-bottom: none;
        }
      }

      .pre-box {
        display: flex;
        padding: 20px 0;
        border-bottom: 1px solid #D2D2D2;
        .left {
          padding-right: 16px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 67%;
          color: #fff;
          p {
            font-size: 14px;
          }
          div {
            font-size: 12px;
            color: #f5f5f5;
            margin-top: 10px;
            span {
              margin-right: 8px;
            }
          }
        }
        .right {
          width: 33%;
          img {
            width: 100%;
            border-radius: 5px;
          }
        }

        &:last-child {
          //border-bottom: none;
          //padding-bottom: 0;
        }
      }

      .xcsp, .jctj, .hjmd {
        .pane-tit {
          border-bottom: none;
        }
      }

      .xcsp {
        .video-wrap {
          width: 100%;
          video {
            width: 100%;
          }
          .vjs-custom-skin > .video-js .vjs-big-play-button {
            background: rgba(0,0,0,0.45);
            width: 2em;
            border-radius: 50%;
            margin-left: -1em;
          }
          .vjs-control-bar {
            button {
              outline: none;
            }
          }
          .video-js {
            background: none;
          }

          >p {
            font-size: 13px;
            padding-top: 20px;
            padding-bottom: 20px;
            color: #fff;
            border-bottom: 1px solid #e3e3e3;
          }
        }
      }

      .jctj {
        .img-list {
          display: flex;
          flex-wrap: wrap;
          >div {
            width: calc((100% - 20px) / 3);
            height: 85px;
            margin-bottom: 10px;
            &:nth-child(3n + 2) {
              margin-left: 10px;
              margin-right: 10px;
            }
            img {
              border-radius: 5px;
              object-fit: cover;
              width: 100%;
              height: 100%;
            }
          }
        }
        .sma-pagination {
          text-align: right;
          .swiper-pagination-bullet {
            width: 7px;
            height: 7px;
            background: transparent;
            border: 1px solid #67D0EC;
            border-radius: 50%;
            margin-left: 5px;
          }
          .swiper-pagination-bullet-active {
            background: #67D0EC;
          }
        }
      }

      .hjmd {
        .hjmd-img {
          display: block;
          width: 100%;
        }
        .award-box {
          color: rgba(253,218,129, .9);
          .com-list {
            div {
              padding: 13px 0;
              text-align: center;
              font-size: 14px;
              &:nth-child(odd) {
                background: rgba(24,189,192, 0.23);
              }
              &:nth-child(even) {
                background: rgba(24,189,192, 0.07);
              }
            }
          }
          &.award-1 {
            margin-bottom: 40px;
          }
        }
      }
    }

    .footer-point {
      text-align: right;
      font-size: 12px;
      color: rgba(253,218,129, .9);
    }
  }
}
</style>